<template>
  <div>
    <h3
      class="membership-post-category__mobile-heading mb-4"
      v-html="category?.name.replace('__', '')"
    ></h3>

    <!-- Desktop -->
    <ArticleSlider
      v-if="!isMobile"
      :heading="category?.name"
      :set-cursor="setCursor"
      :articles="category?.posts?.edges"
    />

    <!-- Mobile -->
    <div v-else class="membership-post-category__mobile-list">
      <template
        v-for="article in visibleArticles"
        :key="article?.node?.id"
      >
        <NuxtLinkLocale
          :to="article?.link"
        >
          <ArticleCard
            :set-cursor="setCursor"
            class="p-0 md:p-3 panel-projects"
            :article="article"
            :show-date="false"
            :show-button="false"
          />
        </NuxtLinkLocale>

        <div class="text-center">
          <button
            v-if="hasMoreArticles && !showAll"
            class="bg-transparent border border-black rounded-full px-3 py-1 font-normal nav-btns pointer-events-auto !font-normal"
            @click="showAll = true"
          >
            {{ $t("membership.buttons.showAll") }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";

const props = defineProps({
  category: {
    type: Object,
    required: true,
  },

  setCursor: {
    type: Function,
    default: null,
  },
});

const isMobile = ref(false);
const BREAKPOINT = 1124;
const showAll = ref(false);
const INITIAL_ITEMS = 1;

const checkBreakpoint = () => {
  isMobile.value = window.innerWidth < BREAKPOINT;
};

onMounted(() => {
  checkBreakpoint();
  window.addEventListener("resize", checkBreakpoint);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkBreakpoint);
});

/**
 * MOBILE ONLY transformation
 */
const processedArticles = computed(() => {
  return (props.category?.posts?.edges || []).map((article) => {
    const node = article?.node;
    if (!node) return null;

    const copy = { ...node };

    const parts = (copy.title || "").split(":");

    if (parts.length > 1) {
      const first = parts.shift();
      copy.title = `<strong>${first}:</strong> ${parts.join(":")}`;
    }

    copy.featuredImage =
      node?.featuredImage?.node?.mediaItemUrl || null;

    copy.perex = node?.blogConfig?.perex;
    copy.isInitialSlide = false;

    return copy;
  }).filter(Boolean);
});

const visibleArticles = computed(() => {
  if (showAll.value) {
    return processedArticles.value;
  }

  return processedArticles.value.slice(0, INITIAL_ITEMS);
});

const hasMoreArticles = computed(() => {
  return processedArticles.value.length > INITIAL_ITEMS;
});

</script>

<style scoped lang="scss">
.membership-post-category {
  &__mobile-heading {
    @media all and (min-width: 1124px) {
      display: none;
    }
  }
}
</style>